import { createContext, useContext } from "react"

const Context = createContext({})
export const Provider = Context.Provider
export function useRetailer() {
  return useContext(Context)
}
